import { ShieldAlert, LifeBuoy } from "lucide-react";
import { C } from "../../theme/tokens";
import { openExternalLink } from "../../utils/video";

const SUPPORT_URL = "https://t.me/MMC_Manager";

/* Full-screen, undismissable lock shown whenever the backend reports
   user.status === false (account restricted by an admin). Rendered
   once at the top of App(), above every other overlay (z-index higher
   than ActiveSignalOverlay's 1000) and with no close affordance of any
   kind — there is intentionally no backdrop click / Escape / back
   button handling, since the whole point is that the account is
   locked until support clears it. */
export function AccountRestrictedOverlay({ t }) {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 2000,
        background: C.canvas,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
      }}
    >
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage: `radial-gradient(circle at 15% 0%, #C4604A22, transparent 55%), radial-gradient(circle at 85% 100%, ${C.violet}1c, transparent 55%)`,
          pointerEvents: "none",
        }}
      />
      <div
        style={{
          position: "relative",
          width: "100%",
          maxWidth: 400,
          borderRadius: 20,
          background: `linear-gradient(155deg, ${C.deep} 0%, ${C.panel2} 65%, ${C.panel1} 100%)`,
          border: `1px solid ${C.hairline}`,
          padding: "36px 28px 28px",
          textAlign: "center",
        }}
      >
        <div
          style={{
            width: 64,
            height: 64,
            borderRadius: "50%",
            background: "#C4604A1f",
            border: "1px solid #C4604A55",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 20px",
          }}
        >
          <ShieldAlert size={30} color="#C4604A" />
        </div>

        <h2
          style={{
            fontFamily: "'Space Grotesk', sans-serif",
            fontSize: 22,
            fontWeight: 700,
            color: C.primary,
            margin: "0 0 10px",
            letterSpacing: "-0.01em",
          }}
        >
          {t.restricted_title}
        </h2>
        <p
          style={{
            fontSize: 14.5,
            lineHeight: 1.5,
            color: C.secondary,
            margin: "0 0 26px",
          }}
        >
          {t.restricted_desc}
        </p>

        <button
          onClick={() => openExternalLink(SUPPORT_URL)}
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 8,
            padding: "15px 18px",
            borderRadius: 14,
            border: "none",
            background: `linear-gradient(120deg, ${C.violet} 0%, ${C.violetBright} 100%)`,
            color: "#0b0d13",
            fontFamily: "'Space Grotesk', sans-serif",
            fontWeight: 700,
            fontSize: 15,
            letterSpacing: "-0.01em",
            cursor: "pointer",
            boxShadow: `0 8px 26px -8px ${C.violetBright}99`,
          }}
        >
          <LifeBuoy size={18} />
          {t.restricted_support}
        </button>
      </div>
    </div>
  );
}
